const CURRENCIES = {
    USD: 'USD',
    RUB: 'RUB',
}

export const DEFAULT_CURRENCY = CURRENCIES.USD
export const DEFAULT_CURRENCY_SYMBOL = '$'

export default CURRENCIES
